import { useRouter } from "next/router"
import { createContext, useContext, useEffect, useRef, useState } from "react"

type LayoutContextValue = {
  focusMain: () => void
  setMainRef: (node: HTMLDivElement) => void
  isShowRoomsScreens: boolean
}

const LayoutContext = createContext<LayoutContextValue>({
  focusMain: () => {},
  setMainRef: () => {},
  isShowRoomsScreens: false,
})

export const useLayoutContext = () => useContext(LayoutContext)

export const LayoutProvider = ({ children }) => {
  const mainRef = useRef<HTMLDivElement | null>(null)
  const { pathname } = useRouter()
  const [isShowRoomsScreens, setIsShowRoomsScreens] = useState<boolean>(false)

  useEffect(() => {
    if (pathname.includes("showroomsscreens")) {
      setIsShowRoomsScreens(true)
    } else {
      setIsShowRoomsScreens(false)
    }
  }, [pathname])

  const value: LayoutContextValue = {
    focusMain: () => mainRef.current?.focus(),
    setMainRef: (node) => (mainRef.current = node),
    isShowRoomsScreens,
  }

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  )
}
